import { render, staticRenderFns } from "./ExportResource.vue?vue&type=template&id=3650a1a6"
import script from "./ExportResource.vue?vue&type=script&lang=js"
export * from "./ExportResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports